// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3-9Kg","rightAdornment":"Header_rightAdornment__vQjYY"};